var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#DAD8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6801 23.2135L24.5934 18.3335C24.2134 17.4402 23.6468 16.9335 23.0001 16.9002C22.3601 16.8668 21.7401 17.3135 21.2668 18.1668L20.0001 20.4402C19.7334 20.9202 19.3534 21.2068 18.9401 21.2402C18.5201 21.2802 18.1001 21.0602 17.7601 20.6268L17.6134 20.4402C17.1401 19.8468 16.5534 19.5602 15.9534 19.6202C15.3534 19.6802 14.8401 20.0935 14.5001 20.7668L13.3468 23.0668C12.9334 23.9002 12.9734 24.8668 13.4601 25.6535C13.9468 26.4402 14.7934 26.9135 15.7201 26.9135H24.2268C25.1201 26.9135 25.9534 26.4668 26.4468 25.7202C26.9534 24.9735 27.0334 24.0335 26.6801 23.2135Z",
    fill: "#B8B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6469 17.5867C17.8914 17.5867 18.9002 16.5779 18.9002 15.3334C18.9002 14.0889 17.8914 13.0801 16.6469 13.0801C15.4024 13.0801 14.3936 14.0889 14.3936 15.3334C14.3936 16.5779 15.4024 17.5867 16.6469 17.5867Z",
    fill: "#B8B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.5cecfb87faf86b8e582ded25399725c1.svg";
export { ForwardRef as ReactComponent };